import(/* webpackMode: "eager" */ "/vercel/path0/app/(frontend)/outillage/page.tsx");
